/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_With_Email_ButtonInputs */

const en_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with email`)
};

const fr_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer avec l'email`)
};

const de_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit der E-Mail fortfahren`)
};

const it_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua con l'email`)
};

const ru_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить отправку электронного письма`)
};

const es_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con el correo electrónico`)
};

const zh_cn2_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续通过电子邮件`)
};

const ja_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールで続行`)
};

const hi_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल के साथ जारी रखें`)
};

const pt_pt2_login_continue_with_email_button = /** @type {(inputs: Login_Continue_With_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com o e-mail`)
};

/**
* | output |
* | --- |
* | "Continue with email" |
*
* @param {Login_Continue_With_Email_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_continue_with_email_button = /** @type {((inputs?: Login_Continue_With_Email_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_With_Email_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_continue_with_email_button(inputs)
	if (locale === "de") return de_login_continue_with_email_button(inputs)
	if (locale === "it") return it_login_continue_with_email_button(inputs)
	if (locale === "ru") return ru_login_continue_with_email_button(inputs)
	if (locale === "es") return es_login_continue_with_email_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_continue_with_email_button(inputs)
	if (locale === "ja") return ja_login_continue_with_email_button(inputs)
	if (locale === "hi") return hi_login_continue_with_email_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_continue_with_email_button(inputs)
	return en_login_continue_with_email_button(inputs)
});